export default __webpack_public_path__ + "static/media/filter-active.ecd14495.svg";